import React from "react";

export const ArrowBackToHome = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <rect x="2.11" y="11" width="21.89" height="2" fill="#444" />
      <polygon points="13.38 1.45 11.97 0.03 1.41 10.59 0 12 1.41 13.41 11.97 23.97 13.38 22.55 2.83 12 13.38 1.45" />
    </svg>
  );
};
